import React, { useState, useEffect, useContext } from 'react';
import MobileRechargeForm from '../../Components/MobileRechargeForm';

import Electricity from '../../Components/Electricity';
import DTH from '../../Components/DTH';
import Exploremore from '../../Components/Exploremore';
import Sendmoney from '../../Components/Sendmoney';
import SendmoneyRoundPay from '../../Components/SendmoneyRoundPay';
import { Wrapper } from './style';
import TabNavItem from './TabNavItem';
import TabContent from './TabContent';
import AEPS from '../AEPS';
import EkoAEPS from '../EkoAEPS';
import InatantPayAEPS from '../InatantPayAEPS';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { isEmpty } from '../../utils/common';
import { GlobleContaxt } from '../../Context/GlobleContaxt';
import { useLocation, useNavigate } from 'react-router-dom';
import AddMoney from '../Addmoney/AddMoney';
import AadharPay from '../AadharPay';
import DQRpage from '../DQR/DQRpage';
import { ServiceBoxWrapper } from '../ServicesBox/style';
import Back from '../UIbox/Back';
import Slider from 'react-slick';
import { tabs } from './constants';
import { providerTypeOptions } from '../ServicesBox/constants';
import Loader from '../UI/Loader/Loader';



function Component() {
	const [activeTab, setActiveTab] = useState('tab1');
	const [moreList, setMoreList] = useState(false);
	const [subActiveTab, setSubActiveTab] = useState('subTab1');

	const { userDetails, apiPermission } = useContext(GlobleContaxt);

	const location = useLocation();
	const navigate = useNavigate();
	
	const state = location.state;


	useEffect(() => {
		if (!isEmpty(state)) {
			setActiveTab(state?.id);
		}
	}, [state]);

	const aepsType = "diosm";

	const tabContentMap = {
		 tab1: <MobileRechargeForm className="mobile-recharge-form" />,
		tab2:  <NavigateBBPS type="ELECTRICITY" />,
		tab3: <NavigateBBPS type="CREDIT CARD" />,
		tab4: <NavigateBBPS type="BROADBAND POSTPAID" />,
		tab5:<NavigateBBPS type="DTH" />,
		tab8: <AddMoney className="electricity-form" />,
		tab6: <></>,
		tab7: <Sendmoney className="send-money-form" />,
		tab14: <SendmoneyRoundPay className="send-money-form" />,
		tab9: <Exploremore className="Exploremore" moreList={moreList} setMoreList={setMoreList} setSubActiveTab={setSubActiveTab} subActiveTab={subActiveTab}  />,
		tab10: <NavigateBBPS type="WATER" />,
		tab11: <AadharPay className="send-money-form" />,
		tab12: <InatantPayAEPS className="send-money-form" />,
		tab13: <DQRpage className="send-money-form" />,
	};

	if(aepsType === 'eko'){
		tabContentMap.tab6 = <EkoAEPS className="send-money-form" />;
	}else if(aepsType === "diosm"){
		tabContentMap.tab6 = <AEPS className="send-money-form" />
	}

	const handleTab = (id) => {
		setActiveTab(id);
	};

	const getMoreOption = (id) => {
		setActiveTab(id);
		moreList ? setMoreList(false) : setMoreList(true);
	};

	useEffect(() =>{
		if(activeTab === "tab9"){
			setMoreList(true)
		}
		
	   },[activeTab])

	   var settings = {
		dots: true,
		infinite: false,
		speed: 500,
		slidesToShow: 7,
		slidesToScroll: 7,
		initialSlide: 0,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 6,
					slidesToScroll: 6,
	
					dots: true,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			},
		],


		
	};


	return (
		<>
		{/* <ServiceBoxWrapper> */}
			 {/* <div className='header flex justify-between items-center'>
			 <Back url="/services" />
            <div className="logo" style={{opacity:"0"}}>
                
            </div>

        </div> */}
		<Wrapper className="home-page">
			  <div className="header-nav" style={{marginBottom:"30px"}}>
				<Slider {...settings}>
					{tabs.map((data, i) =>
						userDetails?.userName === '8527141474' && (data.title === 'AEPS' || data.title === 'Send Money') ? (
							''
						) : data.show === 'all' && isEmpty(userDetails?.userName)  ? (
							<TabNavItem key={i} title={data?.title} icon={data?.icon} id={data?.id} activeTab={activeTab} setActiveTab={handleTab} isActive={activeTab === data.id} />
						) : !isEmpty(userDetails?.userName) && apiPermission.includes(data.apiPermission) ? (
							<TabNavItem key={i} title={data?.title} icon={data?.icon} id={data?.id} activeTab={activeTab} setActiveTab={handleTab} isActive={activeTab === data.id} />
						) : (
							''
						)
					)}
					<TabNavItem key={111} title={'Explore More'} icon={'IconExploreMore'} id={'tab9'} activeTab={activeTab} setActiveTab={getMoreOption} isActive={activeTab === 'tab9'} />
				</Slider>
			</div>  

			{Object.keys(tabContentMap).map((tabId, i) => {
				return (
					<TabContent key={i} id={tabId} activeTab={activeTab}>
						{tabContentMap[tabId]}
					</TabContent>
				);
			})}
		</Wrapper>
		{/* </ServiceBoxWrapper> */}
		</>
	);
}

export default Component;

const NavigateBBPS = ({type}) =>{
	const navigate = useNavigate();

     useEffect(()=>{
			const getItem = providerTypeOptions?.find((item)=>item?.value ===  type);
		  navigate('/bbps-payments', { state:getItem })
	 })
	return(
		<>
		<Loader />
		</>
	)
}